import siteConfig from '../config/siteConfig';

export const CONSENT_STORAGE_KEY = 'kfz-cookie-consent';
export const CONSENT_VERSION = 1;

const isPlaceholderId = (id) => !id || /XXXX/i.test(id);

export const isGoogleAdsConfigured = () => !isPlaceholderId(siteConfig.analytics?.googleAdsId);

export function readConsent() {
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== CONSENT_VERSION || !parsed.status) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writeConsent(status) {
  const record = {
    version: CONSENT_VERSION,
    status,
    date: new Date().toISOString()
  };
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record));
  } catch {
    // localStorage nicht verfügbar (z. B. privater Modus) – Consent gilt dann nur für die Sitzung.
  }
  return record;
}

export function gtag() {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export function initConsentMode() {
  if (window.__kfzConsentModeInit) {
    return;
  }
  window.__kfzConsentModeInit = true;
  // Consent Mode v2 – vor dem Laden von Google Ads gilt alles als abgelehnt.
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 500
  });
}

let googleAdsScriptLoaded = false;

export function loadGoogleAds() {
  const googleAdsId = siteConfig.analytics?.googleAdsId;
  if (isPlaceholderId(googleAdsId) || googleAdsScriptLoaded) {
    return;
  }
  googleAdsScriptLoaded = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(googleAdsId)}`;
  document.head.appendChild(script);
  gtag('js', new Date());
  gtag('config', googleAdsId);
}

export function applyConsent(status) {
  initConsentMode();
  const granted = status === 'granted';
  gtag('consent', 'update', {
    ad_storage: granted ? 'granted' : 'denied',
    ad_user_data: granted ? 'granted' : 'denied',
    ad_personalization: granted ? 'granted' : 'denied',
    analytics_storage: granted ? 'granted' : 'denied'
  });
  if (granted) {
    loadGoogleAds();
  }
}

export function trackContactConversion() {
  const { googleAdsId, contactConversionLabel } = siteConfig.analytics || {};
  const consent = readConsent();
  if (!consent || consent.status !== 'granted') {
    return;
  }
  if (isPlaceholderId(googleAdsId) || !contactConversionLabel) {
    return;
  }
  gtag('event', 'conversion', {
    send_to: `${googleAdsId}/${contactConversionLabel}`
  });
}
